/**
 * placementZoneToLabel
 *
 * Maps internal placement zone codes (LEFT_CHEST, FULL_BACK, ...) to
 * friendly display labels ("Left chest", "Full back", ...) used by the
 * LeftRail subline and any other user-facing surface that needs
 * a human-readable zone name.
 *
 * Co-located with placementZoneToViewCode.js (which maps zone codes to
 * Artifi view codes — a different vocabulary). Keep the two helpers
 * separate; do not merge.
 *
 * Unknown zones return the original code (uppercased) so users can still
 * identify the placement instead of seeing an empty string.
 * Null/undefined/empty inputs return an empty string so callers can use
 * the result in template concatenation without rendering "undefined".
 */

export const PLACEMENT_ZONE_LABELS = Object.freeze({
    LEFT_CHEST: 'Left chest',
    RIGHT_CHEST: 'Right chest',
    FULL_BACK: 'Full back',
    UPPER_BACK: 'Upper back',
    LEFT_SLEEVE: 'Left sleeve',
    RIGHT_SLEEVE: 'Right sleeve',
    HAT_FRONT: 'Hat front',
    HAT_SIDE: 'Hat side',
});

export function placementZoneToLabel(zoneCode) {
    if (zoneCode == null) return '';
    const raw = String(zoneCode);
    if (raw === '') return '';
    const upper = raw.toUpperCase();
    if (Object.prototype.hasOwnProperty.call(PLACEMENT_ZONE_LABELS, upper)) {
        return PLACEMENT_ZONE_LABELS[upper];
    }
    // Unknown zone — return the original code uppercased so the user
    // still gets something identifiable instead of an empty string.
    return upper;
}
